import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";

// img
import moment from "moment";
import { toast } from "react-toastify";
import CustomPagination from "../../../components/Common/CustomPagination";
import Table from "../../../components/Common/Table";
import { GET_NOTIFY, SEND_NOTIFY_EMAIL } from "../../../services/ApiCalls";
import PaginationFilter from "../../../components/Common/PaginationFilter";

const NotifyRequests = () => {
  const [customerData, SetCustomerData] = useState([]);
  const [total, SetTotal] = useState(0);
  const [loader, setLoader] = useState(false);
  const [emailLoader, setEmailLoader] = useState(false);
  const [emailModal, setEmailModal] = useState({
    open: false,
    request: null,
  });
  const [emailForm, setEmailForm] = useState({
    subject: "",
    body: "",
  });

  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
  });

  const getCustomers = async (body) => {
    setLoader(true);
    try {
      const customerRes = await GET_NOTIFY(body);
      console.log(customerRes,"ffff")
      if (customerRes.data.status === "success") {
      
        SetCustomerData(customerRes.data.data);
        SetTotal(customerRes?.data?.totalcount);
        setLoader(false);
      } else {
        setLoader(false);

        toast.error(customerRes.data.message);
      }
    } catch (error) {
      setLoader(false);

      toast.error("something went wrong");
    }
  };

  const pageChangeHandler = async (page) => {
    const newbody = {
      ...body,
      page,
    };
    setBody((p) => ({
      ...p,
      page,
    }));
    getCustomers(newbody);
  };

  const openEmailModal = (request) => {
    setEmailForm({
      subject: "",
      body: "",
    });
    setEmailModal({
      open: true,
      request,
    });
  };

  const closeEmailModal = (forceClose = false) => {
    if (emailLoader && !forceClose) return;

    setEmailModal({
      open: false,
      request: null,
    });
    setEmailForm({
      subject: "",
      body: "",
    });
  };

  const emailChangeHandler = (e) => {
    const { name, value } = e.target;

    setEmailForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSendEmail = async (e) => {
    e.preventDefault();

    if (!emailForm.subject.trim()) {
      toast.error("Please enter email subject");
      return;
    }

    if (!emailForm.body.trim()) {
      toast.error("Please enter email body");
      return;
    }

    const requestId =
      emailModal.request?._id || emailModal.request?.id || emailModal.request?.notifyId;

    if (!requestId) {
      toast.error("Notify request id not found");
      return;
    }

    const payload = {
      id: requestId,
      subject: emailForm.subject.trim(),
      message: emailForm.body.trim(),
    };

    setEmailLoader(true);

    try {
      const res = await SEND_NOTIFY_EMAIL(payload);

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message || "Email sent successfully");
        closeEmailModal(true);
      } else {
        toast.error(res?.data?.message || "something went wrong");
      }
    } catch (error) {
      toast.error("something went wrong");
    } finally {
      setEmailLoader(false);
    }
  };

  const column = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => (
        <p className={` m-0`}>{(body.page - 1) * body.limit + (key + 1)}</p>
      ),
    },
    {
      label: "Email",
      id: "email",
      
    },
    // {
    //   label: "Address",
    //   id: "address"   
    // },
    {
      label: "Type",
      id: "type"   
    },

    // { label: "Email", id: "email" },
    // {
    //   label: "Phone Number",
    //   id: "",
    //   isComponent: true,
    //   component: (item) => (
    //     <p className={` m-0 fw-sbold`}>
    //       {item?.countryCode
    //         ? item?.countryCode + " " + item?.mobileNumber
    //         : "-"}
    //     </p>
    //   ),
    // },
    {
      label: "Created at",
      id: "createdAt",
      isComponent: true,
      component: (item) => (
        <p className={` m-0`}>
          {moment(item.createdAt).format("MM-DD-YYYY , HH:mm A")}
        </p>
      ),
    },
    {
      label: "Actions",
      id: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center gap-10">
          <Button
            aria-label={`Send email to ${item?.email || "request"}`}
            className="border-0 p-0"
            disabled={!item?.email || !(item?._id || item?.id || item?.notifyId)}
            onClick={() => openEmailModal(item)}
            title="Send Email"
            type="button"
            variant="transparent"
          >
            <svg
              fill="none"
              height="18"
              viewBox="0 0 20 18"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.5 3.75C2.5 2.92157 3.17157 2.25 4 2.25H16C16.8284 2.25 17.5 2.92157 17.5 3.75V14.25C17.5 15.0784 16.8284 15.75 16 15.75H4C3.17157 15.75 2.5 15.0784 2.5 14.25V3.75Z"
                stroke="#27AE60"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
              <path
                d="M3 4L10 9.5L17 4"
                stroke="#27AE60"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              />
            </svg>
          </Button>
        </div>
      ),
    },
    // {
    //   label: "Active/Inactive",
    //   id: "",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <Form.Check
    //       type="switch"
    //       id="custom-switch"
    //       checked={item.status}
    //       onClick={() => blockUnBlockHandler(item, ind)}
    //     />
    //   ),
    // },
    // {
    //   label: "View",
    //   id: "",
    //   isComponent: true,
    //   component: (item) => (
    //     <div className="ActnBtn">
    //       <Link
    //         to={`/manage-tiers/view/${item.tierId}`}
    //         className="border-0 p-0"
    //         variant="transparent"
    //       >
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           width="18"
    //           height="18"
    //           viewBox="0 0 25 17"
    //           fill="none"
    //         >
    //           <path
    //             d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
    //             fill="#666666"
    //           />
    //         </svg>
    //       </Link>
    //     </div>
    //   ),
    // },
  ];

  useEffect(() => {
    const newbody = {
      ...body,
      page: 1,
    };

    setBody(newbody);

    if (body?.search.trim() === "") getCustomers(newbody);
  }, [body.search]);

  useEffect(() => {
    const newbody = {
      ...body,
      page: 1,
    };

    setBody(newbody);

    getCustomers(newbody);
  }, [body.status, body.limit]);

  return (
    <>
      <section className="mangeCustomer position-relative py-4">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter gap-10 mb-3 d-flex align-itmes-center justify-content-between flex-wrap">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-itmes-center gap-10">
                    <PaginationFilter setBody={setBody} body={body} />
                    {/* <li className="">
                      <Search setBody={setBody} searchHandler={searchHandler} />
                    </li> */}
                  </ul>
                </div>
                {/* <div className="right">
                  <div className="btnWrpper d-flex align-items-center gap-10">
                   
                    <Button
                      className="d-inline-flex align-items-center justify-content-center commonBtn"
                      type="button"
                      onClick={() => exportCsvHandler("customers")}
                    >
                      Export CSV
                    </Button>
                  </div>
                </div> */}
              </div>
              <div className="table-responsive">
                <Table data={customerData} column={column} loader={loader} />
                <div className="d-flex justify-content-end">
                  <CustomPagination
                    total={total}
                    current={body.page}
                    pageSize={body.limit}
                    pageChangeHandler={pageChangeHandler}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal centered onHide={closeEmailModal} show={emailModal.open} size="lg">
        <Form onSubmit={handleSendEmail}>
          <Modal.Header closeButton>
            <Modal.Title>Send Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>To</Form.Label>
              <Form.Control
                readOnly
                type="email"
                value={emailModal.request?.email || ""}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                disabled={emailLoader}
                name="subject"
                onChange={emailChangeHandler}
                placeholder="Enter email subject"
                type="text"
                value={emailForm.subject}
              />
            </Form.Group>
            <Form.Group className="mb-0">
              <Form.Label>Body</Form.Label>
              <Form.Control
                as="textarea"
                disabled={emailLoader}
                name="body"
                onChange={emailChangeHandler}
                placeholder="Write email body"
                rows={10}
                style={{ minHeight: "280px" }}
                value={emailForm.body}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="d-inline-flex align-items-center justify-content-center commonBtn GreyBtn"
              disabled={emailLoader}
              onClick={closeEmailModal}
              type="button"
            >
              Cancel
            </Button>
            <Button
              className="d-inline-flex align-items-center justify-content-center commonBtn"
              disabled={emailLoader}
              type="submit"
            >
              {emailLoader ? "Sending..." : "Send Email"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default NotifyRequests;
